import { API_BASE_URL } from '../config';

const CSRF_COOKIE = 'XSRF-TOKEN';
const CSRF_HEADER = 'X-XSRF-TOKEN';

function readCookie(name: string): string {
  if (typeof document === 'undefined') return '';
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(`${name}=`)) {
      return decodeURIComponent(trimmed.slice(name.length + 1));
    }
  }
  return '';
}

export function withCsrfHeaders(init?: RequestInit): Headers {
  const headers = new Headers(init?.headers);
  const token = readCookie(CSRF_COOKIE);
  if (token && !headers.has(CSRF_HEADER)) {
    headers.set(CSRF_HEADER, token);
  }
  return headers;
}

export async function ensureCsrfCookie(): Promise<void> {
  try {
    await fetch(`${API_BASE_URL}/api/auth/csrf`, { credentials: 'include' });
  } catch {
    // login will fail with 403 if the cookie never arrives
  }
}
